import { ActionItem, DEPT_OPTIONS, labelStyle, inputStyle } from './types';
import { DEPT_DB_MAP, titleCase } from '../../constants';

interface TransferModalProps {
  selected: ActionItem;
  transferDept: string;
  transferRole: string;
  transferLevel: string;
  transferReason: string;
  transferFinding: string;
  acting: boolean;
  onSetTransferDept: (v: string) => void;
  onSetTransferRole: (v: string) => void;
  onSetTransferLevel: (v: string) => void;
  onSetTransferReason: (v: string) => void;
  onSetTransferFinding: (v: string) => void;
  onSubmit: () => void;
  onClose: () => void;
}

export default function TransferModal({
  selected, transferDept, transferRole, transferLevel, transferReason, transferFinding,
  acting, onSetTransferDept, onSetTransferRole, onSetTransferLevel,
  onSetTransferReason, onSetTransferFinding, onSubmit, onClose,
}: TransferModalProps) {
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div style={{ background: 'var(--bg-elevated)', borderRadius: 12, padding: 24, width: 440, border: '1px solid var(--bg-border)' }}>
        <h3 style={{ fontSize: 16, fontWeight: 700, color: 'var(--text-primary)', marginBottom: 16 }}>Transfer Action #{selected.id}</h3>
        <p style={{ fontSize: 12, color: 'var(--text-dim)', marginBottom: 12 }}>
          Move this action to a different department for specialized review.
        </p>
        <div style={{ marginBottom: 10 }}>
          <label style={labelStyle}>Department</label>
          <select value={transferDept} onChange={e => onSetTransferDept(e.target.value)} style={inputStyle}>
            <option value="">Select department...</option>
            {DEPT_OPTIONS.map(d => (
              <option key={d} value={d}>{titleCase(DEPT_DB_MAP[d] || d)}</option>
            ))}
          </select>
        </div>
        <div style={{ display: 'flex', gap: 10, marginBottom: 10 }}>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Role</label>
            <input value={transferRole} onChange={e => onSetTransferRole(e.target.value)} placeholder="e.g. tax_analyst" style={inputStyle} />
          </div>
          <div style={{ flex: '0 0 80px' }}>
            <label style={labelStyle}>Level</label>
            <select value={transferLevel} onChange={e => onSetTransferLevel(e.target.value)} style={inputStyle}>
              {['L2','L3','L4','L5','L6','L7'].map(l => <option key={l} value={l}>{l}</option>)}
            </select>
          </div>
        </div>
        <div style={{ marginBottom: 10 }}>
          <label style={labelStyle}>Reason (required)</label>
          <textarea value={transferReason} onChange={e => onSetTransferReason(e.target.value)} placeholder="Why are you transferring?" style={{ ...inputStyle, minHeight: 60, resize: 'vertical' }} />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label style={labelStyle}>Finding (optional)</label>
          <textarea value={transferFinding} onChange={e => onSetTransferFinding(e.target.value)} placeholder="What did you find during review?" style={{ ...inputStyle, minHeight: 50, resize: 'vertical' }} />
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          <button onClick={onClose}
            style={{ flex: 1, padding: 10, background: 'transparent', border: '1px solid var(--bg-border)', borderRadius: 6, color: 'var(--text-dim)', cursor: 'pointer', fontSize: 12 }}>
            Cancel
          </button>
          <button onClick={onSubmit} disabled={!transferDept || !transferReason.trim() || acting}
            style={{ flex: 1, padding: 10, background: transferDept && transferReason.trim() ? '#fffbeb' : 'rgba(0,0,0,0.03)', border: '1px solid rgba(245,158,11,0.3)', borderRadius: 6, color: transferDept && transferReason.trim() ? '#f59e0b' : 'var(--text-dim)', cursor: transferDept && transferReason.trim() ? 'pointer' : 'not-allowed', fontSize: 12, fontWeight: 700 }}>
            Transfer
          </button>
        </div>
      </div>
    </div>
  );
}
